import type { NormalizedLocale } from '@jet-app/music-classical/dependencies/locale';
import type {
    MetricsFieldsBuilder,
    MetricsFieldsContext,
    MetricsFieldsProvider,
} from '@jet/engine';

export class StorefrontFieldsProvider implements MetricsFieldsProvider {
    constructor(private readonly context: Map<string, unknown>) {
        this.context = context;
    }

    addMetricsFields(
        builder: MetricsFieldsBuilder,
        _context: MetricsFieldsContext,
    ) {
        const { storefront } = this.context.get('locale') as NormalizedLocale;
        builder.addValue(storefront, 'storeFrontCountryCode');
    }
}
